'use client'

import { useEffect } from 'react'

// Extend Window interface to include dataLayer
declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

export interface GTMScriptProps {
  /**
   * GTM Container ID.
   */
  gtmId: string
}

/**
 * Google Tag Manager Script component
 * Loads GTM with the specified container ID.
 * Uses the official GTM implementation from Google.
 */
export const GTMScript: React.FC<GTMScriptProps> = ({ gtmId }) => {
  useEffect(() => {
    // Check if GTM is already loaded
    const existingScript = document.querySelector(
      `script[src*="googletagmanager.com/gtm.js"][src*="${gtmId}"]`,
    )
    if (existingScript) {
      return
    }

    // Official GTM snippet - initialize dataLayer and inject GTM script
    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
    ;(function (w, d, s, l, i) {
      // @ts-expect-error - Official GTM snippet uses dynamic property access
      w[l] = w[l] || []
      // @ts-expect-error - Official GTM snippet uses dynamic property access
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      const f = d.getElementsByTagName(s)[0]
      const j = d.createElement(s) as HTMLScriptElement
      const dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      j.id = 'gtm-script-' + i
      f.parentNode?.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', gtmId)
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
  }, [gtmId])

  return <></>
}
